<template>
  <div class="NewWorkerForm" id="new-worker-form">
    <div class="row">
      <div class="col-md-4 col-sm-12">
        <label :for="'new-fullname_last'">
          Фамилия
        </label>
        <b-form-input
          id="new-fullname_last"
          class="form-control"
          v-model="personal.fullname_last"
        />
        <typeahead
          :async-function="personalTypeaheadQuery"
          :limit="5"
          target="#new-fullname_last"
          item-key="fullname_last"
          v-model="typeahead.fullname_last"
          @input="selectTypeahead"
        >
          <template slot="item" slot-scope="props">
            <li :key="index" v-for="(item, index) in props.items" :class="{active:props.activeIndex===index}">
              <a role="button">
                <span v-html="props.highlight(item)" /> <span>{{ item.fullname_first }}</span> <span>{{ item.fullname_patronymic }}</span>
              </a>
            </li>
          </template>
        </typeahead>
      </div>
      <div class="col-md-4 col-sm-12">
        <label :for="'new-fullname_first'">
          Имя
        </label>
        <b-form-input
          id="new-fullname_first"
          v-model="personal.fullname_first"
          class="form-control"
        />
        <typeahead
          :async-function="personalTypeaheadQuery"
          :limit="5"
          target="#new-fullname_first"
          item-key="fullname_first"
          v-model="typeahead.fullname_first"
          @input="selectTypeahead"
        >
          <template slot="item" slot-scope="props">
            <li :key="index" v-for="(item, index) in props.items" :class="{active:props.activeIndex===index}">
              <a role="button">
                <span>{{ item.fullname_last }}</span> <span v-html="props.highlight(item)" /> <span>{{ item.fullname_patronymic }}</span>
              </a>
            </li>
          </template>
        </typeahead>
      </div>
      <div class="col-md-4 col-sm-12">
        <label :for="'new-fullname_patronymic'">
          Отчество
        </label>
        <b-form-input
          id="new-fullname_patronymic"
          v-model="personal.fullname_patronymic"
          class="form-control"
        />
        <typeahead
          :async-function="personalTypeaheadQuery"
          :limit="5"
          target="#new-fullname_patronymic"
          item-key="fullname_patronymic"
          v-model="typeahead.fullname_patronymic"
          @input="selectTypeahead"
        >
          <template slot="item" slot-scope="props">
            <li :key="index" v-for="(item, index) in props.items" :class="{active:props.activeIndex===index}">
              <a role="button">
                <span>{{ item.fullname_last }}</span> <span>{{ item.fullname_first }}</span> <span v-html="props.highlight(item)" />
              </a>
            </li>
          </template>
        </typeahead>
      </div>
    </div>
    <div class="row text-center" style="margin-top: 20px">
      <button
        class="btn btn-primary btn-primary-blue"
        @click="createVisitor"
      >
        Добавить
      </button>
    </div>
  </div>
</template>

<script>
import { RestTimeApplicationTypeaheads } from '../../helpers/api-client/RestTimeApplicationTypeaheads';

export default {
  name: 'NewWorkerForm',

  props: {
    /**
     * Add visitor function callback
     * @type function(visitor = {})
     */
    addWorker: {
      type: Function
    }
  },

  data () {
    return {
      typeahead: {
        fullname_first: null,
        fullname_last: null,
        fullname_patronymic: null
      },
      personal: {
        fullname_first: null,
        fullname_last: null,
        fullname_patronymic: null
      }
    }
  },

  methods: {
    createVisitor() {
      this.addWorker({ personal: this.personal, new: true })
      this.clearForm()
    },

    clearForm() {
      this.personal = {
        fullname_first: null,
        fullname_last: null,
        fullname_patronymic: null
      }
    },

    async personalTypeaheadQuery(query, done) {
      await RestTimeApplicationTypeaheads.personal(query)
        .then(function (data) {
          done(data)
        })
    },

    selectTypeahead(item) {
      if (item instanceof Object) {
        this.$set(this, 'personal', item)
      }
    }
  }
}
</script>
